<template>
    <b-container fluid class="align-self-center">
        <b-row>
            <b-col cols="12">
                <h2 class="text-center my-4">New client</h2>
            </b-col>
            <b-col md="12" class="flex-center">
                <b-form v-on:submit.prevent="createClient" class="w-75">
                    <b-form-group
                        horizontal
                        :label-cols="4"
                        breakpoint="md"
                        label="Name:"
                        label-for="name">
                        <b-form-input id="name"
                                      type="text"
                                      size="sm"
                                      name="name"
                                      required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        horizontal
                        :label-cols="4"
                        breakpoint="md"
                        label="Address:"
                        label-for="address">
                        <b-form-input id="address"
                                      type="text"
                                      size="sm"
                                      name="address"
                                      required>

                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        horizontal
                        :label-cols="4"
                        breakpoint="md"
                        label="Owner:"
                        label-for="owner">
                        <b-form-input id="owner"
                                      type="text"
                                      size="sm"
                                      name="owner"
                                      required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        horizontal
                        :label-cols="4"
                        breakpoint="md"
                        label="Contact:"
                        label-for="contact">
                        <b-form-input id="contact"
                                      type="text"
                                      size="sm"
                                      name="contact"
                                      required>
                        </b-form-input>
                    </b-form-group>
                    <!--<b-form-group-->
                    <!--horizontal-->
                    <!--:label-cols="4"-->
                    <!--breakpoint="md"-->
                    <!--label="ID Broj:"-->
                    <!--label-for="id_number">-->
                    <!--<b-form-input id="id_number"-->
                    <!--type="text"-->
                    <!--size="sm"-->
                    <!--name="id_number"-->
                    <!--maxlength="13"-->
                    <!--required>-->
                    <!--</b-form-input>-->
                    <!--</b-form-group>-->
                    <b-btn type="submit" variant="primary" class="pull-right">Confirm</b-btn>
                </b-form>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        methods: {
            createClient: function (e) {
                const formData = new FormData(e.target);
                adamApi.post(api.clients, formData).then( response => {
                        if (response.status === 201) {
                            this.$router.push('/clients/' + response.data.id);
                        }
                    }
                )
            }
        }
    }
</script>
